import React from "react";
import { MessageCircle } from "lucide-react";
import { publicWhatsappGroupUrl } from "../../utils/publicEventsApi";

/** Opens the event's public WhatsApp group in a new tab. Renders nothing without a link. */
const JoinWhatsappGroupLink = ({ event, className }) => {
  const href = publicWhatsappGroupUrl(event);
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
      <MessageCircle className="h-4 w-4 shrink-0" aria-hidden />
      Join WhatsApp group
    </a>
  );
};

export default JoinWhatsappGroupLink;
